export type ParsedUsAddress = {
  street: string
  city: string
  state: string
  zip: string
  display: string
}

const EMPTY_ADDRESS: ParsedUsAddress = {
  street: '',
  city: '',
  state: '',
  zip: '',
  display: '',
}

export function formatUsAddressDisplay(parts: {
  street?: string
  city?: string
  state?: string
  zip?: string
}): string {
  const street = (parts.street ?? '').trim()
  const city = (parts.city ?? '').trim()
  const state = (parts.state ?? '').trim()
  const zip = (parts.zip ?? '').trim()
  const cityState = [city, state].filter(Boolean).join(', ')
  const cityStateZip = [cityState, zip].filter(Boolean).join(' ')
  return [street, cityStateZip].filter(Boolean).join(', ')
}

export function parseUsMailingAddress(raw: string): ParsedUsAddress {
  const t = raw.replace(/\s+/g, ' ').trim()
  if (!t) return { ...EMPTY_ADDRESS }

  const withComma = t.match(/^(.*?)[,\s]+([^,]+),\s*([A-Za-z]{2})\s+(\d{5}(?:-\d{4})?)$/)
  if (withComma) {
    const street = withComma[1].trim().replace(/,$/, '')
    const city = withComma[2].trim()
    const state = withComma[3].toUpperCase()
    const zip = withComma[4]
    return {
      street,
      city,
      state,
      zip,
      display: formatUsAddressDisplay({ street, city, state, zip }),
    }
  }

  const noComma = t.match(/^(.*)\s+([A-Za-z][A-Za-z .'-]*?)\s+([A-Za-z]{2})\s+(\d{5}(?:-\d{4})?)$/)
  if (noComma) {
    const street = noComma[1].trim().replace(/,$/, '')
    const city = noComma[2].trim()
    const state = noComma[3].toUpperCase()
    const zip = noComma[4]
    if (street) {
      return {
        street,
        city,
        state,
        zip,
        display: formatUsAddressDisplay({ street, city, state, zip }),
      }
    }
  }

  return { street: t, city: '', state: '', zip: '', display: t }
}
